export const circleCarousel = () => ({
    active: 1,
    buttons: JSON.parse(document.querySelector('.circle-carousel').dataset.buttons),

    init() {
        this.$nextTick(() => this.initSwiper(1))
    },

    initSwiper(n) {
        const el = this.$refs['swiper' + n]
        if (!el) return

        if (el.swiper) {
            el.swiper.slideTo(0, 0)
            return
        }

        const swiperParams = {
            watchSlidesProgress: true,
            on: {
                progress(swiper) {
                    swiper.slides.forEach((slide) => {
                        const circle = slide.querySelector('.circle-carousel__circle');
                        if (!circle) return;

                        const p = slide.progress;
                        const clamped = Math.min(Math.abs(p), 1);
                        const rotate = 0 - clamped * 90;

                        circle.style.transform = `rotate(${rotate}deg)`;
                    });
                },
                setTransition(swiper, duration) {
                    swiper.slides.forEach((slide) => {
                        const circle = slide.querySelector('.circle-carousel__circle');
                        if (!circle) return;
                        circle.style.transitionDuration = `${duration}ms`;
                    });
                },
            },
        };

        Object.assign(el, swiperParams);
        el.initialize()
    },

    show(n) {
        this.active = n
        this.$nextTick(() => this.initSwiper(n))

        const el = document.querySelector('.circle-carousel__button');
        el.click()
    },

    get activeButton() {
        return this.buttons[this.active - 1] ?? []
    },
    isActive(i) {
        return i === this.active
    },
})